import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";
import { scrollTriggerDefaults } from "@/lib/animations";
import { clientRect } from "@/utils/client-rect";
import { Scroll } from "@/lib/scroll";
import { Raf, Resize } from "@/lib/subs";

export default function (element, dataset) {
  const rect = clientRect(element);
  let scrollHeight = Number(Scroll.dimensions.scrollHeight);
  let tl;

  const resizeUnsubscribe = Resize.add(({ width, height }) => {
    initStickyPill();
  });

  const rafUnsubscribe = Raf.add(() => {
    if (scrollHeight !== Scroll.dimensions.scrollHeight) {
      initStickyPill();
    }
  });

  onMount(() => {
    initStickyPill();
  });

  function initStickyPill() {
    if (tl) {
      tl.kill();
    }
    const pillDistance = Scroll.dimensions.scrollHeight - rect.normalTop * 2;

    tl = gsap.timeline({
      scrollTrigger: {
        ...scrollTriggerDefaults,
        trigger: element,
        endTrigger: document.body,
        start: "center 20%",
        end: "bottom bottom",
      },
      defaults: {
        ease: "none",
      },
    });

    tl.to(element, {
      y: "+=" + pillDistance,
    });

    scrollHeight = Number(Scroll.dimensions.scrollHeight);
  }

  onDestroy(() => {
    rafUnsubscribe();
    resizeUnsubscribe();
    tl.kill();
  });
}
